import CommentInput from './CommentInput'
import CommentInputContianer from './CommentInputContainer'

export default CommentInputContianer(CommentInput)
